import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import ActionTypesEnum from '@shared/enums/action-constant.enum';
import { CustomEventService } from '@shared/services/custom-event.service';

import { UntilDestroy } from '@ngneat/until-destroy';
import { PropertiesService } from "@core/services/properties.service";

@UntilDestroy()
@Component({
  selector: 'app-delete-confirm-modal',
  templateUrl: './delete-confirm-modal.component.html'
})
export class DeleteConfirmModalComponent {

  @Input() loading: boolean;
  @Input() data: any = {};
  @Input() title: string;
  @Input() description: string;
  @Input() inputLabel: string;
  @Input() value: string;
  @Input() buttonText: string;
  @Input() deploymentAnalyticsForm: boolean;

  deleteForm: FormGroup;

  constructor(
    private customEventService: CustomEventService,
    private fb: FormBuilder,
    public propertiesService: PropertiesService
  ) {
    this.deleteForm = this.fb.group({
      name: ['', [Validators.required]]
    });
  }

  cancelModal(): void {
    this.customEventService.announceEvent(ActionTypesEnum.CLOSE_MODAL);
  }

  deleteConfirm(): void {
    const name = this.deleteForm.get('name');

    if (name.value !== this.value) {
      name.setErrors({notEqual: true});
    }

    if (this.deleteForm.invalid) {
      return;
    }

    this.customEventService.announceEvent(ActionTypesEnum.DELETE_CONFIRM, this.data);
    this.customEventService.announceEvent(ActionTypesEnum.CLOSE_MODAL);
  }
}
